export const serverConfig = {
    // appServerUrl: 'http://localhost:5000',
    appServerUrl: 'https://mchopan.cyclic.app/'
};